import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { stripUnit } from 'polished'

import SectionComponent from '../Section'

import fluidRange from '../../utils/fluidRange'
import { ColorDeterminer, WidthContainer } from '../../utils/helpers.styles'

export const Section = styled(SectionComponent)(
  WidthContainer,
  ColorDeterminer,
  ({ theme }) => css`
    ${fluidRange('padding-top', [
      stripUnit(theme.spacing.sm),
      stripUnit(theme.spacing.sm),
    ])};
    ${fluidRange('padding-bottom', [
      stripUnit(theme.spacing.sm),
      stripUnit(theme.spacing.sm),
    ])};
  `
)
